import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { AuxiaResponse } from "./get-auxia-jsm-paid-lp-treatment";

function isValidAuxiaResponse(
    auxiaResponse: AuxiaResponse | null | undefined
): auxiaResponse is AuxiaResponse {
    return (
        auxiaResponse !== null &&
        auxiaResponse !== undefined &&
        typeof auxiaResponse.treatmentId === "string" &&
        typeof auxiaResponse.treatmentTrackingId === "string" &&
        auxiaResponse.treatmentId.length > 0 &&
        auxiaResponse.treatmentTrackingId.length > 0 &&
        Array.isArray(auxiaResponse.auxiaTreatment) &&
        auxiaResponse.auxiaTreatment.length > 0
    );
}

export const isAuxiaServedPage = (
    auxiaResponse: AuxiaResponse | null | undefined
): auxiaResponse is AuxiaResponse => {
    const usingAuxiaTreatment = checkFeatureFlagGate(
        featureFlags.jsmPaidLpAuxiaIntegration
    );

    return usingAuxiaTreatment && isValidAuxiaResponse(auxiaResponse);
};

export const isAuxiaResponseMalformed = (
    auxiaResponse: AuxiaResponse | null | undefined
): auxiaResponse is AuxiaResponse => {
    const usingAuxiaTreatment = checkFeatureFlagGate(
        featureFlags.jsmPaidLpAuxiaIntegration
    );

    return usingAuxiaTreatment && !isValidAuxiaResponse(auxiaResponse);
};
